function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { ColorBatch } from 'components';
import { dateFormat, loanPurposeName, loanAbsorptionName, paymentStatusColorMap, paymentStatusName, CREDIT_STATUS, CREDIT_PAYMENT_TYPE } from 'enums';
import { sumForTotalCell, convertToAdditionalCurrency, oppositeCurrency } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
var draft = CREDIT_STATUS.draft,
    awaiting_approval = CREDIT_STATUS.awaiting_approval,
    approved = CREDIT_STATUS.approved; // ── Styles ───────────────────────────────

var container = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2em'
};

var sectionHeader = function sectionHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6em',
    paddingBottom: '0.8em',
    borderBottom: "1px solid ".concat(theme.gray150),
    marginBottom: '1em',
    '& i': {
      fontSize: '1.6rem',
      color: theme.primary
    },
    '& span': {
      fontSize: '1.3rem',
      fontWeight: 600,
      color: theme.gray700,
      textTransform: 'uppercase',
      letterSpacing: '0.04em'
    }
  };
};

var grid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
  gap: '1.2em 2em'
};

var fieldStyle = function fieldStyle(theme) {
  return {
    '& .fl': {
      fontSize: '1.15rem',
      color: theme.gray400,
      marginBottom: '0.3em',
      fontWeight: 500
    },
    '& .fv': {
      fontSize: '1.4rem',
      color: theme.gray800,
      fontWeight: 500,
      wordBreak: 'break-word'
    },
    '& .fv.empty': {
      color: theme.gray300,
      fontStyle: 'italic'
    },
    '& .fv-sub': {
      fontSize: '1.2rem',
      color: theme.gray400,
      fontWeight: 400
    }
  };
};

var summaryGrid = function summaryGrid(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: '1em',
    '& .summary-card': {
      padding: '1em',
      backgroundColor: theme.gray50,
      border: "1px solid ".concat(theme.gray100)
    },
    '& .summary-label': {
      fontSize: '1.1rem',
      color: theme.gray400,
      fontWeight: 500,
      marginBottom: '0.4em'
    },
    '& .summary-value': {
      fontSize: '1.5rem',
      color: theme.gray800,
      fontWeight: 600
    },
    '& .summary-sub': {
      fontSize: '1.15rem',
      color: theme.gray400,
      fontWeight: 400
    }
  };
};

var highlightCard = function highlightCard(theme) {
  return {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.2em 1.6em',
    backgroundColor: theme.primaryLight,
    border: "1px solid ".concat(theme.primary),
    '& .hl-label': {
      fontSize: '1.3rem',
      color: theme.gray600,
      fontWeight: 500
    },
    '& .hl-value': {
      fontSize: '1.8rem',
      color: theme.primary,
      fontWeight: 700
    },
    '& .hl-sub': {
      fontSize: '1.2rem',
      color: theme.gray500,
      fontWeight: 400,
      textAlign: 'right'
    }
  };
};

var tableWrap = function tableWrap(theme) {
  return {
    overflowX: 'auto',
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '1.2rem'
    },
    '& th': {
      textAlign: 'left',
      padding: '0.8em 0.6em',
      fontWeight: 600,
      color: theme.gray500,
      borderBottom: "2px solid ".concat(theme.gray200),
      whiteSpace: 'nowrap',
      fontSize: '1.1rem',
      textTransform: 'uppercase',
      letterSpacing: '0.03em'
    },
    '& td': {
      padding: '0.7em 0.6em',
      borderBottom: "1px solid ".concat(theme.gray100),
      color: theme.gray700,
      verticalAlign: 'top'
    },
    '& tr:hover td': {
      backgroundColor: theme.gray50
    },
    '& tfoot td': {
      fontWeight: 600,
      borderBottom: 'none',
      borderTop: "2px solid ".concat(theme.gray200),
      color: theme.gray800
    },
    '& .sub-val': {
      fontSize: '1.1rem',
      color: theme.gray400
    }
  };
}; // ── Helpers ──────────────────────────────


var Field = function Field(_ref) {
  var label = _ref.label,
      value = _ref.value,
      sub = _ref.sub;
  return ___EmotionJSX("div", {
    css: fieldStyle
  }, ___EmotionJSX("p", {
    className: "fl"
  }, label), ___EmotionJSX("p", {
    className: "fv".concat(!value ? ' empty' : '')
  }, value || '—'), sub && ___EmotionJSX("p", {
    className: "fv-sub"
  }, sub));
};

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  sub: PropTypes.string
};

var PriceField = function PriceField(_ref2) {
  var label = _ref2.label,
      value = _ref2.value,
      currency = _ref2.currency,
      fromCurrency = _ref2.fromCurrency;
  return ___EmotionJSX("div", {
    css: fieldStyle
  }, ___EmotionJSX("p", {
    className: "fl"
  }, label), ___EmotionJSX("p", {
    className: "fv"
  }, value != null ? "".concat(value, " ").concat(currency) : '—'), ___EmotionJSX("p", {
    className: "fv-sub"
  }, convertToAdditionalCurrency({
    value: value,
    fromCurrency: fromCurrency || currency
  })));
};

PriceField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  currency: PropTypes.string,
  fromCurrency: PropTypes.string
};

var Section = function Section(_ref3) {
  var icon = _ref3.icon,
      title = _ref3.title,
      children = _ref3.children;
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: sectionHeader
  }, ___EmotionJSX("i", {
    className: icon
  }), ___EmotionJSX("span", null, title)), children);
};

Section.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node
};

var fmt = function fmt(val) {
  return moment(val).isValid() ? moment(val).format(dateFormat) : '—';
};

var toAlt = function toAlt(value, fromCurrency) {
  return convertToAdditionalCurrency({
    value: value,
    fromCurrency: fromCurrency,
    noLabel: true
  });
}; // ── Component ────────────────────────────


var CreditData = function CreditData(_ref4) {
  var _credit$total_amount_, _credit$home_visit_fe, _credit$home_visit_fe2, _credit$total_princip, _credit$total_interes, _credit$total_fees_to, _credit$total_penalty, _credit$total_home_vi, _credit$contact_perso, _credit$contact_perso2, _credit$total_home_vi2, _credit$total_payed_a, _credit$total_amount_2;

  var credit = _ref4.credit,
      isRefinance = _ref4.isRefinance,
      showMergedPlan = _ref4.showMergedPlan;
  var cur = credit === null || credit === void 0 ? void 0 : credit.currency;
  var isDraftOrApprovedOrAwaiting = (credit === null || credit === void 0 ? void 0 : credit.status) === draft || (credit === null || credit === void 0 ? void 0 : credit.status) === approved || (credit === null || credit === void 0 ? void 0 : credit.status) === awaiting_approval;
  var hasSeparateHomeVisitFee = (credit === null || credit === void 0 ? void 0 : credit.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment;
  var paymentPlan = showMergedPlan ? credit === null || credit === void 0 ? void 0 : credit.combined_payment_plan : isDraftOrApprovedOrAwaiting ? credit === null || credit === void 0 ? void 0 : credit.payment_plan : credit === null || credit === void 0 ? void 0 : credit.combined_payment_plan;
  return ___EmotionJSX("div", {
    style: container
  }, ___EmotionJSX("div", {
    css: highlightCard
  }, ___EmotionJSX("div", null, ___EmotionJSX("p", {
    className: "hl-label"
  }, "\u041E\u0431\u0449\u0430 \u0441\u0443\u043C\u0430 \u0437\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435")), ___EmotionJSX("div", null, ___EmotionJSX("p", {
    className: "hl-value"
  }, (_credit$total_amount_ = credit === null || credit === void 0 ? void 0 : credit.total_amount_to_be_payed) !== null && _credit$total_amount_ !== void 0 ? _credit$total_amount_ : '—', " ", cur), ___EmotionJSX("p", {
    className: "hl-sub"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.total_amount_to_be_payed,
    fromCurrency: cur
  })))), ___EmotionJSX(Section, {
    icon: "las la-file-invoice",
    title: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(PriceField, {
    label: "\u0421\u0443\u043C\u0430",
    value: credit === null || credit === void 0 ? void 0 : credit.amount,
    currency: cur
  }), ___EmotionJSX(Field, {
    label: "\u0421\u0440\u043E\u043A",
    value: credit !== null && credit !== void 0 && credit.period_months ? "".concat(credit.period_months, " \u043C\u0435\u0441\u0435\u0446\u0430") : null
  }), ___EmotionJSX(Field, {
    label: "\u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0434\u0430\u0442\u0430",
    value: fmt(credit === null || credit === void 0 ? void 0 : credit.date)
  }), ___EmotionJSX(Field, {
    label: "\u041A\u0440\u0430\u0439\u043D\u0430 \u0434\u0430\u0442\u0430",
    value: fmt(credit === null || credit === void 0 ? void 0 : credit.date_end)
  }), ___EmotionJSX(Field, {
    label: "\u041D\u0438\u0432\u043E \u043D\u0430 \u0440\u0438\u0441\u043A",
    value: credit === null || credit === void 0 ? void 0 : credit.risk_level
  }), (credit === null || credit === void 0 ? void 0 : credit.days_late) >= 0 && ___EmotionJSX(Field, {
    label: "\u0414\u043D\u0438 \u0437\u0430\u043A\u044A\u0441\u043D\u0435\u043D\u0438\u0435",
    value: credit === null || credit === void 0 ? void 0 : credit.days_late
  }), ___EmotionJSX(Field, {
    label: "\u041D\u0430\u0447\u0438\u043D \u043D\u0430 \u0443\u0441\u0432\u043E\u044F\u0432\u0430\u043D\u0435",
    value: loanAbsorptionName[credit === null || credit === void 0 ? void 0 : credit.loan_absorption]
  }), ___EmotionJSX(Field, {
    label: "\u0426\u0435\u043B \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    value: loanPurposeName[credit === null || credit === void 0 ? void 0 : credit.loan_purpose]
  }), ___EmotionJSX(Field, {
    label: "\u0414\u043E\u043C\u0430\u0448\u043D\u043E \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u0435",
    value: (credit === null || credit === void 0 ? void 0 : credit.home_visit_contract) === 1 ? 'Да' : 'Не'
  }), ___EmotionJSX(Field, {
    label: "\u041B\u0438\u0445\u0432\u0435\u043D \u043F\u0440\u043E\u0446\u0435\u043D\u0442",
    value: credit !== null && credit !== void 0 && credit.interest_percent ? "".concat(credit.interest_percent, "%") : null
  }), ___EmotionJSX(Field, {
    label: "\u0413\u041F\u0420",
    value: credit !== null && credit !== void 0 && credit.gpr ? "".concat(credit.gpr, "%") : null
  }), (credit === null || credit === void 0 ? void 0 : (_credit$home_visit_fe = credit.home_visit_fee_payment_plan) === null || _credit$home_visit_fe === void 0 ? void 0 : (_credit$home_visit_fe2 = _credit$home_visit_fe[0]) === null || _credit$home_visit_fe2 === void 0 ? void 0 : _credit$home_visit_fe2.amount) && ___EmotionJSX(PriceField, {
    label: "\u041C\u0435\u0441\u0435\u0447\u043D\u0430 \u0442\u0430\u043A\u0441\u0430 \u0414\u041F",
    value: credit.home_visit_fee_payment_plan[0].amount,
    currency: cur
  })), isRefinance && ___EmotionJSX("div", {
    style: _objectSpread(_objectSpread({}, grid), {}, {
      marginTop: '1em'
    })
  }, ___EmotionJSX(PriceField, {
    label: "\u0421\u0443\u043C\u0430 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0432\u0430\u043D\u0435",
    value: credit === null || credit === void 0 ? void 0 : credit.amount_to_be_received_from_client,
    currency: cur
  })), (credit === null || credit === void 0 ? void 0 : credit.refinance_credit) && ___EmotionJSX("div", {
    style: {
      marginTop: '0.8em'
    }
  }, ___EmotionJSX(Field, {
    label: "\u0420\u0435\u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430 \u043A\u0440\u0435\u0434\u0438\u0442",
    value: ___EmotionJSX(Link, {
      to: "/credits/details/".concat(credit.refinance_credit.id)
    }, credit.refinance_credit.number)
  })), (credit === null || credit === void 0 ? void 0 : credit.refinanced_from_credit) && ___EmotionJSX("div", {
    style: {
      marginTop: '0.8em'
    }
  }, ___EmotionJSX(Field, {
    label: "\u0420\u0435\u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u043D \u043E\u0442",
    value: ___EmotionJSX(Link, {
      to: "/credits/details/".concat(credit.refinanced_from_credit.id)
    }, credit.refinanced_from_credit.number)
  }))), ___EmotionJSX(Section, {
    icon: "las la-coins",
    title: "\u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0430 \u0440\u0430\u0437\u0431\u0438\u0432\u043A\u0430"
  }, ___EmotionJSX("div", {
    css: summaryGrid
  }, ___EmotionJSX("div", {
    className: "summary-card"
  }, ___EmotionJSX("p", {
    className: "summary-label"
  }, "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0430"), ___EmotionJSX("p", {
    className: "summary-value"
  }, (_credit$total_princip = credit === null || credit === void 0 ? void 0 : credit.total_principal_to_be_payed) !== null && _credit$total_princip !== void 0 ? _credit$total_princip : '—', " ", cur), ___EmotionJSX("p", {
    className: "summary-sub"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.total_principal_to_be_payed,
    fromCurrency: cur
  }))), ___EmotionJSX("div", {
    className: "summary-card"
  }, ___EmotionJSX("p", {
    className: "summary-label"
  }, "\u041B\u0438\u0445\u0432\u0430"), ___EmotionJSX("p", {
    className: "summary-value"
  }, (_credit$total_interes = credit === null || credit === void 0 ? void 0 : credit.total_interest_to_be_payed) !== null && _credit$total_interes !== void 0 ? _credit$total_interes : '—', " ", cur), ___EmotionJSX("p", {
    className: "summary-sub"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.total_interest_to_be_payed,
    fromCurrency: cur
  }))), ___EmotionJSX("div", {
    className: "summary-card"
  }, ___EmotionJSX("p", {
    className: "summary-label"
  }, "\u0422\u0430\u043A\u0441\u0438"), ___EmotionJSX("p", {
    className: "summary-value"
  }, (_credit$total_fees_to = credit === null || credit === void 0 ? void 0 : credit.total_fees_to_be_payed) !== null && _credit$total_fees_to !== void 0 ? _credit$total_fees_to : '—', " ", cur), ___EmotionJSX("p", {
    className: "summary-sub"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.total_fees_to_be_payed,
    fromCurrency: cur
  }))), ___EmotionJSX("div", {
    className: "summary-card"
  }, ___EmotionJSX("p", {
    className: "summary-label"
  }, "\u041B\u0438\u0445\u0432\u0430 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0438\u0435"), ___EmotionJSX("p", {
    className: "summary-value"
  }, (_credit$total_penalty = credit === null || credit === void 0 ? void 0 : credit.total_penalty_to_be_payed) !== null && _credit$total_penalty !== void 0 ? _credit$total_penalty : '—', " ", cur), ___EmotionJSX("p", {
    className: "summary-sub"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.total_penalty_to_be_payed,
    fromCurrency: cur
  }))), hasSeparateHomeVisitFee && ___EmotionJSX("div", {
    className: "summary-card"
  }, ___EmotionJSX("p", {
    className: "summary-label"
  }, "\u0414\u043E\u043C\u0430\u0448\u043D\u043E \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u0435"), ___EmotionJSX("p", {
    className: "summary-value"
  }, (_credit$total_home_vi = credit === null || credit === void 0 ? void 0 : credit.total_home_visit_fee_rest) !== null && _credit$total_home_vi !== void 0 ? _credit$total_home_vi : '—', " ", cur), ___EmotionJSX("p", {
    className: "summary-sub"
  }, convertToAdditionalCurrency({
    value: credit === null || credit === void 0 ? void 0 : credit.total_home_visit_fee_rest,
    fromCurrency: cur
  }))))), (credit === null || credit === void 0 ? void 0 : credit.contact_person) && ___EmotionJSX(Section, {
    icon: "las la-address-book",
    title: "\u041B\u0438\u0446\u0435 \u0437\u0430 \u043A\u043E\u043D\u0442\u0430\u043A\u0442"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(Field, {
    label: "\u0418\u043C\u0435",
    value: [credit.contact_person.first_name, credit.contact_person.middle_name, credit.contact_person.last_name].filter(Boolean).join(' ')
  }), ___EmotionJSX(Field, {
    label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
    value: credit.contact_person.phone
  }), ___EmotionJSX(Field, {
    label: "\u041E\u0431\u043B\u0430\u0441\u0442",
    value: (_credit$contact_perso = credit.contact_person.area) === null || _credit$contact_perso === void 0 ? void 0 : _credit$contact_perso.name
  }), ___EmotionJSX(Field, {
    label: "\u041E\u0431\u0449\u0438\u043D\u0430",
    value: (_credit$contact_perso2 = credit.contact_person.municipality) === null || _credit$contact_perso2 === void 0 ? void 0 : _credit$contact_perso2.name
  }), ___EmotionJSX(Field, {
    label: "\u0413\u0440\u0430\u0434/\u0441\u0435\u043B\u043E",
    value: credit.contact_person.city ? "".concat(credit.contact_person.city.type, " ").concat(credit.contact_person.city.name) : null
  }), ___EmotionJSX(Field, {
    label: "\u0410\u0434\u0440\u0435\u0441",
    value: [credit.contact_person.street && "\u0443\u043B. ".concat(credit.contact_person.street), credit.contact_person.street_number && "\u2116 ".concat(credit.contact_person.street_number), credit.contact_person.building && "\u0431\u043B. ".concat(credit.contact_person.building), credit.contact_person.entrance && "\u0432\u0445. ".concat(credit.contact_person.entrance), credit.contact_person.floor && "\u0435\u0442. ".concat(credit.contact_person.floor), credit.contact_person.apartment && "\u0430\u043F. ".concat(credit.contact_person.apartment)].filter(Boolean).join(', ') || null
  }))), (credit === null || credit === void 0 ? void 0 : credit.guarantor) && ___EmotionJSX(Section, {
    icon: "las la-user-shield",
    title: "\u041F\u043E\u0440\u044A\u0447\u0438\u0442\u0435\u043B"
  }, ___EmotionJSX("div", {
    style: grid
  }, ___EmotionJSX(Field, {
    label: "\u0418\u043C\u0435",
    value: [credit.guarantor.first_name, credit.guarantor.middle_name, credit.guarantor.last_name].filter(Boolean).join(' ')
  }), ___EmotionJSX(Field, {
    label: "\u0415\u0413\u041D",
    value: ___EmotionJSX(Link, {
      to: "/borrowers/details/".concat(credit.guarantor.id_number)
    }, credit.guarantor.id_number)
  }))), ___EmotionJSX(Section, {
    icon: "las la-calendar-alt",
    title: "\u041F\u043E\u0433\u0430\u0441\u0438\u0442\u0435\u043B\u0435\u043D \u043F\u043B\u0430\u043D"
  }, ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX("table", null, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("th", null, "\u0421\u0443\u043C\u0430"), ___EmotionJSX("th", null, "\u041B\u0438\u0445\u0432\u0430"), ___EmotionJSX("th", null, "\u0413\u043B\u0430\u0432\u043D\u0438\u0446\u0430"), ___EmotionJSX("th", null, "\u0422\u0430\u043A\u0441\u0438"), ___EmotionJSX("th", null, "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0438\u0435"), (!isDraftOrApprovedOrAwaiting || showMergedPlan) && hasSeparateHomeVisitFee && ___EmotionJSX("th", null, "\u0422\u0430\u043A\u0441\u0430 \u0414\u041F"), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("th", null, "\u041F\u043B\u0430\u0442\u0435\u043D\u043E"), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("th", null, "\u041E\u0441\u0442\u0430\u0432\u0430\u0442"), ___EmotionJSX("th", null, "\u0412\u0430\u043B\u0443\u0442\u0430"), ___EmotionJSX("th", null, "\u0421\u0442\u0430\u0442\u0443\u0441"))), ___EmotionJSX("tbody", null, paymentPlan === null || paymentPlan === void 0 ? void 0 : paymentPlan.map(function (el, index) {
    var _el$home_visit_fee_am;

    return ___EmotionJSX("tr", {
      key: (el === null || el === void 0 ? void 0 : el.id) || "".concat(el === null || el === void 0 ? void 0 : el.date, "-").concat(index)
    }, ___EmotionJSX("td", null, fmt(el === null || el === void 0 ? void 0 : el.date)), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.total_amount, ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.total_amount, (el === null || el === void 0 ? void 0 : el.currency) || cur))), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.interest, ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.interest, (el === null || el === void 0 ? void 0 : el.currency) || cur))), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.amount, ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.amount, (el === null || el === void 0 ? void 0 : el.currency) || cur))), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.fees, ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.fees, (el === null || el === void 0 ? void 0 : el.currency) || cur))), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.penalty, ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.penalty, (el === null || el === void 0 ? void 0 : el.currency) || cur))), (!isDraftOrApprovedOrAwaiting || showMergedPlan) && hasSeparateHomeVisitFee && ___EmotionJSX("td", null, (_el$home_visit_fee_am = el === null || el === void 0 ? void 0 : el.home_visit_fee_amount) !== null && _el$home_visit_fee_am !== void 0 ? _el$home_visit_fee_am : '0.00', ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.home_visit_fee_amount, (el === null || el === void 0 ? void 0 : el.currency) || cur))), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.total_payed_amount, ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.total_payed_amount, (el === null || el === void 0 ? void 0 : el.currency) || cur))), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.total_rest_amount, ___EmotionJSX("div", {
      className: "sub-val"
    }, toAlt(el === null || el === void 0 ? void 0 : el.total_rest_amount, (el === null || el === void 0 ? void 0 : el.currency) || cur))), ___EmotionJSX("td", null, (el === null || el === void 0 ? void 0 : el.currency) || cur, ___EmotionJSX("div", {
      className: "sub-val"
    }, oppositeCurrency((el === null || el === void 0 ? void 0 : el.currency) || cur))), ___EmotionJSX("td", null, ___EmotionJSX(ColorBatch, {
      type: paymentStatusColorMap[el === null || el === void 0 ? void 0 : el.status],
      fontSize: "1rem"
    }, paymentStatusName[el === null || el === void 0 ? void 0 : el.status])));
  })), ___EmotionJSX("tfoot", null, ___EmotionJSX("tr", null, ___EmotionJSX("td", null, ___EmotionJSX("b", null, "\u0422\u043E\u0442\u0430\u043B ", cur, ":")), ___EmotionJSX("td", null, sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_amount_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_amount)), ___EmotionJSX("td", null, sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_interest_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_interest)), ___EmotionJSX("td", null, sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_principal_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_principal)), ___EmotionJSX("td", null, sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_fees_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_fees)), ___EmotionJSX("td", null, sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_penalty_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_penalty)), (!isDraftOrApprovedOrAwaiting || showMergedPlan) && hasSeparateHomeVisitFee && ___EmotionJSX("td", null, (_credit$total_home_vi2 = credit === null || credit === void 0 ? void 0 : credit.total_home_visit_fee) !== null && _credit$total_home_vi2 !== void 0 ? _credit$total_home_vi2 : '0.00'), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("td", null, (_credit$total_payed_a = credit === null || credit === void 0 ? void 0 : credit.total_payed_amount) !== null && _credit$total_payed_a !== void 0 ? _credit$total_payed_a : '0.00'), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("td", null, (_credit$total_amount_2 = credit === null || credit === void 0 ? void 0 : credit.total_amount_to_be_payed) !== null && _credit$total_amount_2 !== void 0 ? _credit$total_amount_2 : '0.00'), ___EmotionJSX("td", null), ___EmotionJSX("td", null)), ___EmotionJSX("tr", null, ___EmotionJSX("td", null, ___EmotionJSX("b", null, "\u0422\u043E\u0442\u0430\u043B ", oppositeCurrency(cur), ":")), ___EmotionJSX("td", null, toAlt(sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_amount_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_amount), cur)), ___EmotionJSX("td", null, toAlt(sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_interest_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_interest), cur)), ___EmotionJSX("td", null, toAlt(sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_principal_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_principal), cur)), ___EmotionJSX("td", null, toAlt(sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_fees_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_fees), cur)), ___EmotionJSX("td", null, toAlt(sumForTotalCell(credit === null || credit === void 0 ? void 0 : credit.total_penalty_to_be_payed, credit === null || credit === void 0 ? void 0 : credit.total_payed_penalty), cur)), (!isDraftOrApprovedOrAwaiting || showMergedPlan) && hasSeparateHomeVisitFee && ___EmotionJSX("td", null, toAlt(credit === null || credit === void 0 ? void 0 : credit.total_home_visit_fee, cur)), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("td", null, toAlt(credit === null || credit === void 0 ? void 0 : credit.total_payed_amount, cur)), !isDraftOrApprovedOrAwaiting && ___EmotionJSX("td", null, toAlt(credit === null || credit === void 0 ? void 0 : credit.total_amount_to_be_payed, cur)), ___EmotionJSX("td", null), ___EmotionJSX("td", null)))))));
};

CreditData.propTypes = {
  credit: PropTypes.object,
  isRefinance: PropTypes.bool,
  showMergedPlan: PropTypes.bool
};
export default CreditData;